import { render } from "./OurPartnership.vue?vue&type=template&id=7cd3bf52&scoped=true"
import script from "./OurPartnership.vue?vue&type=script&lang=js"
export * from "./OurPartnership.vue?vue&type=script&lang=js"

import "./OurPartnership.vue?vue&type=style&index=0&id=7cd3bf52&scoped=true&lang=css"

import exportComponent from "/home/aria/Documents/gawean/pt.ksi/program/vue/ksi_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cd3bf52"]])

export default __exports__